export default {
    url: '/application',
    template: '<ui-view></ui-view>',
    abstract: true
};



// WEBPACK FOOTER //
// ./src/app/states/authorized/courses/application/index.js